/*
 ** options: {
 **   type, lang, pageSize(optional), orderings(optional), page(optional)
 ** }
 */

export const fetchAllDocuments = async (
  prismic,
  options,
  hasNextPage = true,
  allResults = []
) => {
  if (!hasNextPage) return allResults

  const { results, next_page } = await prismic.api.query(
    prismic.predicates.at('document.type', options.type),
    {
      lang: options.lang,
      pageSize: options.pageSize || 100,
      page: options.page || 1,
      orderings: options.orderings,
    }
  )

  if (options.page === undefined) {
    options.page = 1
  }

  allResults.push(...results)
  options.page++
  return await fetchAllDocuments(prismic, options, next_page, allResults)
}
